/**
  * All rights Reserved, Designed By www.feidai.com
  * @Title:  iousServices.ts
  * @Package :
  * @author:青瞳科技
  * @date:   2022/7/6 14:13
  * @version V1.0
  * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
  * @Belong To: 青瞳科技
  * 注意：本内容仅限于深圳青瞳科技有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
  */

/* 第三方服务-金融服务模块 */

const iousRouter = [
    {
      path: '/iousServices',
      name: 'IOUsServices',
      component: () =>
              import(/* webpackChunkName: "iousServices" */ '@/views/iousServices/cashier.vue'),
      meta: {
        title: '收银台',
        deepth: 4,
        // permission: true
      },
    },
    {
      path: '/iousAuthorize',
      name: 'IOUsAuthorize',
      component: () =>
              import(/* webpackChunkName: "iousServices" */ '@/views/iousServices/iousAuthorize.vue'),
      meta: {
        title: '信息授权书',
        deepth: 1
      },
    },
    {
      path: '/authorizeConfirm',
      name: 'AuthorizeConfirm',
      component: () =>
              import(/* webpackChunkName: "iousServices" */ '@/views/iousServices/authorizeConfirm.vue'),
      meta: {
        title: '认证通过',
        deepth: 1
      },
    },
    {
      path: '/supplementInfo',
      name: 'SupplementInfo',
      component: () =>
              import(/* webpackChunkName: "iousServices" */ '@/views/iousServices/supplementInfo.vue'),
      meta: {
        title: '白条快付',
        deepth: 1
      },
    }
  ]

 export default iousRouter
